//interfaces
import { IUseCommentLike } from "@/interfaces/activityFeedNotifications";
import {  ActionFeedback } from "thrive-components";

//helpers
import { getCommentArchivalBannerMessage } from "@/helpers/ActivityFeed";


export function getCommentLike({ isPopOut, timeStamp, dateStamp, comment, content, appDetails, notificationDetails}: IUseCommentLike) {
    const showDeletedBanner = content.isArchived || comment.isDeleted
    const deletedBannerMessage = getCommentArchivalBannerMessage(content?.isArchived);
    const deletedCommentClassName = comment.isDeleted ? "deleted-comment" : "";
    const screenClassName = isPopOut ? "" : "full-screen-styling";
    const showFeedbackBanner : boolean = !!notificationDetails;
    const feedbackType = notificationDetails?.isSuccess ? ActionFeedback.SUCCESS : ActionFeedback.ERROR;
    const feedbackMessage = notificationDetails?.message ?? '';
    const truncation = isPopOut ?  50 : 228;
    const hideMenu = content.isArchived;
    const time = isPopOut ? timeStamp : undefined;
    const date =`${timeStamp} · ${dateStamp}`;
    const appImageUrl = appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "";
    const appName = appDetails.isMultipleAppOrganisation ? appDetails.name : "";
    const contentTitle = content.isArchived ? undefined : content.title;
    const contentLink = content.isArchived ? undefined : content.link;

    return { screenClassName, deletedCommentClassName, showDeletedBanner, deletedBannerMessage, truncation, showFeedbackBanner, feedbackType, feedbackMessage, hideMenu, time, date, appImageUrl, appName, contentTitle, contentLink }
};